import React from "react"
import Carousel from "react-multi-carousel"
import styles from "./SimpleCarousel.module.scss"
import "react-multi-carousel/lib/styles.css"
import { Button, Typography } from '@mui/material'
import { KeyboardArrowRight, KeyboardArrowLeft } from '@mui/icons-material'

const cardMaxWidth = 350

const SimpleCarousel = ({ title, children}) => {

  const range = (start, stop, step = 1) =>
  Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)

  const responsiveRange = range(1, 3000, cardMaxWidth )

  const responsive = Object.assign({}, ...responsiveRange.map((item, index)=> ({['desktop'+index]: {
    breakpoint: { max: item + cardMaxWidth, min: item },
    items: index+1,
    slidesToSlide: index+1,
    partialVisibilityGutter: 60
  }})))

  const RigthArrow = (arrowProps) => { 
    const {carouselState, children, ...restArrowProps} = arrowProps
    return ( <Button {...restArrowProps} classes={{root: styles['btn']}} fontSize='small' variant="outlined"> {children} </Button> ) 
  }

  const LeftArrow = (arrowProps) => { 
    const {carouselState, children, ...restArrowProps} = arrowProps
    return (<Button {...restArrowProps} classes={{root: `${styles['btn']} ${styles['left']}`}} fontSize='small' variant="outlined"> {children} </Button> ) 
  }

  return (
    <>
      { children?.length 
        ? <div className={styles['container']}>
          <Typography variant="h2">{title}</Typography>
          <Carousel
          containerClass={styles['list-items']}
          responsive={responsive}
          autoPlay={false}
          draggable={false}
          sliderClass={styles['slider']}
          itemClass={styles['card']}
          renderArrowsWhenDisabled
          customRightArrow={<RigthArrow> <KeyboardArrowRight/> </RigthArrow>}
          customLeftArrow={<LeftArrow> <KeyboardArrowLeft/> </LeftArrow>}
          >
            {children}
          </Carousel>
        </div> 
        : <></>}
    </>
  )
}

export default SimpleCarousel
